module.exports = __webpack_public_path__ + "static/media/07_plantilla_combo_rectangular_fondo_1.5cd027ef.jpg";